export const InputPresets = {
  className: '',
  help: '',
  onBlur: () => {},
  onChange: () => {},
  placeholder: '',
  type: 'text',
  value: '',
};
